import React from 'react';

import ApprovalCheckList from 'components/campaign/campaignCreation/ApprovalCheckList';
import ContentPreviewCard from 'components/campaignStreamline/ContentPreviewCard';
import EarningRulePreviewCard from 'components/campaignStreamline/EarningRulePreviewCard';
import { CampaignType, EarningRuleRewardType } from 'config/CustomEnums';
import { returnDefaultValueWhileEmpty } from 'utils/StringUtil';
import CouponSetPreviewCard from 'components/campaignStreamline/CouponSetPreviewCard';
import CouponCampaignEaringRulePreviewCard from 'components/campaignStreamline/CouponCampaignEaringRulePreviewCard';
import {
  CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY,
  CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY
} from 'config/PageAnchorConfig/CampaignAnchorConfig';

const ExtraTopSection = ({ formContext: { watch } }) => {
  const displayInFrontend = watch("displayInFrontend");
  return <div
    id={CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.contentPage}
    className='create-campaign-preview-page-extra-top-section'
  >
    <label
      id={CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.displayInFrontend.sectionKey}
      className="create-section-title"
    >
      DISPLAY THIS CAMPAIGN IN FRONTEND
    </label>
    <span className='create-campaign-preview-page-extra-top-value'>
      {returnDefaultValueWhileEmpty(displayInFrontend, true) ? "Yes" : "No"}
    </span>
    <div className='create-campaign-preview-page-split-line' />
  </div>
};


export const CREATE_CAMPAIGN_PREVIEW_PAGE_CONFIG = {
  extraValidate: ({ getValues, setError, clearErrors }) => true,
  getDisplayComponentKeys: ({ formContext: { watch, getValues } }) => {
    const campaignPk = watch('pk');
    const campaignType = watch('campaignType');
    const haveCreatedCoupon = watch('haveCreatedCoupon');
    const EarningCampaignRewardType = watch("linkedEarningRules.rewardType")
    const showCouponTemplateReview = !haveCreatedCoupon &&
      (campaignType === CampaignType.couponsCampaign ||
        (campaignType === CampaignType.earningRulesCampaign &&
          EarningCampaignRewardType === EarningRuleRewardType.coupons)
      )

    const displayLanguageSectionComponents = [
      'language_content_section_key',
      'campaign_content_section_key',
      'campaign_earning_rule_section_key',
    ];

    if (showCouponTemplateReview) {
      displayLanguageSectionComponents.push('campaign_coupon_section_key');
    }

    if (
      campaignType === CampaignType.couponsCampaign && (
        haveCreatedCoupon
      )
    ) {
      displayLanguageSectionComponents.push('checklist_key');
    };

    return {
      displayNormalSectionComponents: [],
      displayLanguageSectionComponents,
    };
  },
  normalSections: [],
  languageExtraTopSection: ExtraTopSection,
  languageSections: [
    {
      sectionContent: [
        {
          key: 'campaign_content_section_key',
          complexComponent: ({ formContext: { getValues }, language }) => (
            <ContentPreviewCard
              language={language}
              campaignData={getValues()}
            />
          ),
        },
      ],
    },
    {
      sectionKey: CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.earningRulePage,
      sectionTitle: "ruleAndProperties",
      sectionContent: [
        {
          key: 'campaign_earning_rule_section_key',
          complexComponent: ({ formContext: { getValues, watch }, language }) => (
            watch("campaignType") === CampaignType.couponsCampaign ?
              <CouponCampaignEaringRulePreviewCard
                language={language}
                campaignData={getValues()}
              /> :
              <EarningRulePreviewCard
                language={language}
                campaignData={getValues()}
              />
          ),
        },
      ],
    },
    {
      sectionKey: CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.couponPage,
      sectionTitle: "couponContent",
      sectionContent: [
        {
          key: 'campaign_coupon_section_key',
          complexComponent: ({ formContext: { getValues }, language }) => (
            <CouponSetPreviewCard
              language={language}
              couponTemplateData={getValues("campaignCouponTemplate") || {}}
              isWithinCreationFlow={true}
            />
          ),
        },
      ],
    },
    {
      sectionKey: CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.checklist,
      sectionContent: [
        {
          key: 'checklist_key',
          component: ApprovalCheckList,
        },
      ],
    },
  ],
};
